import React from 'react'
import './Blogsec.css'
import bimg from '../../assets/blog/DFT-Training-for-Freshers.jpg'
import img1 from '../../assets/blog/ASIC-verification-roadmap.jpg'
import img2 from '../../assets/blog/physical-design-roadmap.png'
import img3 from '../../assets/blog/VLSI-Design-Journey-From-RTL-to-Silicon.jpg'
import img4 from '../../assets/blog/VLSI-Engineer-Practicing-Chip-Design.jpg'
import { Link } from 'react-router-dom'

const Blogsec = () => {
  return (
    <div class="blog-section ws-section pb-lg-5">
        <div class="container text-center">
            <div class="row justify-content-center pb-5">
                <div class="col-lg-6">
                    <h2 class="ws-section_heading">Blogs</h2>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-7">
                    <a href='/blog/dft-training-for-freshers/'>
                    <div className='latestPostCard mb-3'>
                        <div class="latestPostCard-img">
                            <img src={bimg} alt=''/>
                        </div>
                        <div class="latestPostCard-content">
                        <h6 class="latestPostCard-title text-white mb-4">DFT Training for Freshers: Scan, ATPG and a Practical Career Guide</h6>
                        <div className='d-flex justify-content-between'>
                        <div className='latestPostCard-left d-flex justify-content-between'>
                        <div class="latestPostCard-author-name text-white me-3 text-xs text-md-lg">By admin</div>
                        <div class="ms-latestPostCard__author-date-text ms-para text-white">November 2, 2026</div>
                        </div>
                        <div class="latestPostCard-category text-white">VLSI Industry</div>
                        </div>
                       
                    </div>
                    </div>
                    </a>
                </div>
                <div class="col-lg-5">
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        
                        <a href='/blog/asic-verification-roadmap/'>
                        <div class="postCard-thumbnail overflow-hidden">
                                <img src={img1} alt=''/>
                        </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">ASIC Verification Roadmap: From Digital Basics to SystemVerilog and UVM</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Nov 1, 2026</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        <a href='/blog/vlsi-physical-design-roadmap-step-by-step-learning-path/'>
                            <div class="postCard-thumbnail overflow-hidden">
                                <img src={img2} alt=''/>
                            </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">VLSI Physical Design Roadmap: A Step-by-Step Learning Path from RTL to GDSII</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Oct 31, 2026</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        <a href='/blog/rtl-to-silicon-complete-vlsi-design-journey/'>
                            <div class="postCard-thumbnail overflow-hidden">
                                <img src={img3} alt=''/>
                            </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">From RTL to Silicon: Understanding the Complete VLSI Design Journey
</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Oct 26, 2026</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        <a href='/blog/vlsi-engineer-skills-before-applying-for-jobs/'>
                            <div class="postCard-thumbnail overflow-hidden">
                                <img src={img4} alt=''/>
                            </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">What Skills Should a VLSI Engineer Build Before Applying for Jobs?</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Oct 25, 2026</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Blogsec